import React, { useEffect, useState } from 'react';
import { Col } from 'react-bootstrap';
import SignOut from "../../assets/svg/signout.svg";
import { getbasicDetAPi } from '../topbar/topbar-api';
import ProfileImg from "../../assets/png/user-icon.png";
const LogoutModal = ({ isVisible, onConfirm, onClose, headerDetails }) => {
    const accountsUrl = process.env.REACT_APP_ACCOUNTS_URL;
    const handleOutsideClick = (e) => {
        if (e.target.id === 'logout-overlay') {
            onClose();
        }
    };

    useEffect(() => {
        console.log("headerDetails")
        console.log(headerDetails)
        if (!isVisible) {
            // getbasicDetails("");
        }
    }, [isVisible]);



    // const getbasicDetails = async () => {

    //     try {
    //         const response = await getbasicDetAPi()
    //         if (response.status === true) {
    //             setHeaderDetails(response.user ?? {});

    //         }
    //         return response.data;
    //     } catch (err) {
    //         console.error("Error fetching category:", err);
    //     } finally {
    //     }
    // }
    if (!isVisible) return null;
    const modalStyle = {
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'flex-end',
            zIndex: 1000,
            padding: '24px',
            pointerEvents: 'none', // optional: to let clicks go through if needed
        },
        modal: {
            backgroundColor: '#fff',
            padding: '24px',
            borderRadius: '12px',
            width: '400px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
            maxWidth: '90%',
            border: 'none',
            marginTop: '20px',
            marginRight: '20px',
            pointerEvents: 'auto', // make sure modal can still be interacted with
        },
    };


    return (
        <div
            id="logout-overlay"
            onClick={handleOutsideClick}
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1000,
                // backgroundColor: 'rgba(0, 0, 0, 0.3)', // optional: background
            }}
        >
            <div style={modalStyle.overlay}>
                <div style={modalStyle.modal}>
                    <Col className="d-flex flex-column align-items-center">
                        <div style={{ backgroundColor: '#FFFFFF', padding: '16px', }} className="col-3">
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', marginBottom: '16px' }}>
                                <div style={{}}>
                                    <img src={ProfileImg} alt="" style={{ width: '80px', height: '80px', borderRadius: '100px' }} />
                                </div>
                                <span style={{ fontFamily: "Epilogue", fontWeight: '700', fontSize: '20px', lineHeight: '27px', color: '#212129' }}>{headerDetails['first_name'] ?? ''}{' '}{headerDetails['last_name'] ?? ''}</span>
                                <span style={{ fontFamily: "Epilogue", fontWeight: '400', fontSize: '13px', lineHeight: '17.55px', color: '#8790A1' }}>{headerDetails['email'] ?? ''}</span>
                            </div>
                            {/* <span style={{ fontFamily: "Epilogue", fontWeight: '700', fontSize: '20px', lineHeight: '27px', color: '#212129' }}>{headerDetails['first_name'] ?? ''}{' '}{headerDetails['last_name'] ?? ''}</span>
                        <span style={{ fontFamily: "Epilogue", fontWeight: '400', fontSize: '13px', lineHeight: '17.55px', color: '#8790A1' }}>{headerDetails['email'] ?? ''}</span> */}
                            <div onClick={() => {
                                onConfirm();
                            }} style={{ cursor: 'pointer', display: 'flex', padding: '0px', alignItems: 'center' }}>
                                <img src={SignOut} alt="" style={{ marginRight: '5%' }} />
                                <span style={{ fontFamily: "Epilogue", paddingLeft: '12px', fontWeight: '500', fontSize: '14px', lineHeight: '18.9px', color: '#FF4444' }}>Signout</span>
                            </div>
                        </div>
                    </Col>
                </div>
            </div>
        </div>
    );
};

export default LogoutModal;
